/**
 * 子系统管理模块
 * 
 * 项目配置、容器管理、健康检查、日志
 */

import type { WorkbenchModule } from '../types'

export const subsystemsModule: WorkbenchModule = {
  meta: {
    name: 'subsystems',
    title: '子系统管理',
    description: '项目容器管理、健康检查、日志查看',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/subsystems',
      name: 'subsystems',
      component: () => import('./views/SubsystemsView.vue'),
      meta: { title: '子系统管理' }
    },
    {
      path: '/subsystems/:id',
      name: 'subsystem-detail',
      component: () => import('./views/SubsystemDetailView.vue'),
      meta: { title: '子系统详情' }
    }
  ],
  menuItem: {
    id: 'subsystems',
    label: '子系统管理',
    path: '/subsystems',
    icon: 'subsystems',
    order: 50
  }
}
